//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/Drawer'
import { eventEmitter } from '@/main.js'
export default {
	name: 'main-layout',
	components: {
		Drawer,
	},
	data: () => ({
		padding: '',
		loading: false,
		isOpen: false,
	}),
	async created() {},
	methods: {
		toggleResize(padding) {
			this.padding = padding
		},
	},
}
